'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initModules = undefined;

var _helpers = require('../_helpers');

var _functional = require('../../utils/functional');

var initModules = exports.initModules = function initModules(modulesList) {
  var _loop = function _loop(i) {
    var _modulesList$i = modulesList[i],
        name = _modulesList$i.name,
        init = _modulesList$i.init;

    (0, _functional.getElements)('[data-module=' + name + ']').forEach(function (el) {
      var context = (0, _helpers.createContext)(el);

      init({ el: el, context: context });
    });
  };

  for (var i = 0; i < modulesList.length; i++) {
    _loop(i);
  }
};